import * as React from "react";
import { WaveLandingPage } from "patient/src/components/uiControllers/waveLandingPage";

//region [[ Styles ]]

//endregion [[ Styles ]]

//region [[ Props ]]

export interface NiceErrorProps {
  error: any;
  message: any;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const NiceError = ({ error, message, ...props }: NiceErrorProps) => {
  return (
    <WaveLandingPage
      title={"Ooops..."}
      contentText={
        "Seems like something isn't quite working, please try again soon..."
      }
    >
      <pre>
        <code>{JSON.stringify({ error, message }, null, 4)}</code>
      </pre>
    </WaveLandingPage>
  );
};
